import React from "react";

import { IDSSModal } from "../../DSSFramework";
import DLSModal from "../../../dls/dls-modal/dls-modal";


export const DSSModal = (props: IDSSModal): JSX.Element =>
{

    return (<DLSModal { ...props }>{ props.children }</DLSModal>);
};